/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step4_BodyInputs */

const es_cap_step4_body = /** @type {(inputs: Cap_Step4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibes a los clientes a bordo, haces la salida y cobras de forma segura por la plataforma.`)
};

const gl_cap_step4_body = /** @type {(inputs: Cap_Step4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibes aos clientes a bordo, fas a saída e cobras de forma segura pola plataforma.`)
};

const en_cap_step4_body = /** @type {(inputs: Cap_Step4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome guests aboard, run the trip, and get paid securely through the platform.`)
};

/**
* | output |
* | --- |
* | "Welcome guests aboard, run the trip, and get paid securely through the platform." |
*
* @param {Cap_Step4_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step4_body = /** @type {((inputs?: Cap_Step4_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step4_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step4_body(inputs)
	if (locale === "en") return en_cap_step4_body(inputs)
	return es_cap_step4_body(inputs)
});